import styled from "styled-components";
import Table from "../DataTable";
import ListWithPagination from "../ListsWithPagination";
import LinkTextModal from "../LinkTextModal";

interface Props {
  data: any;
  isTableDataLoading: boolean;
}
const AquaReportTable = ({ data, isTableDataLoading }: Props) => {
  const columns = [
    {
      path: "created",
      label: "Created Date/Time",
    },
    {
      path: "ticket_id",
      label: "Ticket ID",
    },
    {
      path: "booked_by",
      label: "Booked by",
      content: (data: any) => (
        <DoubleRowContainer width="100px">
          <b style={{ textTransform: "capitalize", marginBottom: "0.5rem" }}>
            {data.booked_by_type}
          </b>
          <span>{data.booked_by}</span>
        </DoubleRowContainer>
      ),
    },
    {
      path: "guest",
      label: "Guest",
      // content:(data:any)=>{<>{data?.guest_name}{data?.guest_email}</>}
      content: (data: any) => (
        <DoubleRowContainer width="12rem">
          <span>{data.guest_name}</span>
          <span>{data.guest_email}</span>
        </DoubleRowContainer>
      ),
    },
    {
      path: "product",
      label: "Product",
      content: (data: any) => (
        <DoubleRowContainer width="100%" maxWidth="15rem">
          {data?.product?.toString()}
        </DoubleRowContainer>
      ),
    },
    {
      path: "booking_date",
      label: "Booking Date",
    },
    {
      path: "payment",
      label: "Payment",
      content: (data: any) => (
        <DoubleRowContainer>
          <span>{data.payment_amount} QAR</span>
          <span>{data.payment_type}</span>
        </DoubleRowContainer>
      ),
    },
    {
      path: "signature",
      label: "Signature",
      content: (data: any) => (
        <SignatureContainer>
          <img src={data?.signature} />
          {data?.signature ? <span>View</span> : <em>NA</em>}
        </SignatureContainer>
      ),
    },
  ];

  return (
    <>
      <TableWrapper>
        <Table
          columns={columns}
          data={data}
          isTableDataLoading={isTableDataLoading}
        />
      </TableWrapper>
      <ListWrapper>
        <ListWithPagination
          columns={columns}
          data={data}
          isTableDataLoading={isTableDataLoading}
          title={""}
          hidePagination={true}
          currentPage={0}
          totalData={0}
          rowsPerPage={0}
          onPageChange={function (page: number): void {
            throw new Error("Function not implemented.");
          }}
        />
      </ListWrapper>
    </>
  );
};
const TableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  @media only screen and (max-width: 768px) {
    padding-top: 4.5rem;
    display: none;
  }
`;
const ListWrapper = styled.div`
  display: none;
  @media only screen and (max-width: 768px) {
    display: block;
  }
`;

interface DoubleRowContainerProps {
  width?: string;
  maxWidth?: string;
}

const DoubleRowContainer = styled.div<DoubleRowContainerProps>`
  width: ${(props) => props.width || "100px"};
  max-width: ${(props) => props.maxWidth || "100%"};
  display: flex;
  flex-direction: column;
`;

const SignatureContainer = styled.div`
  position: relative;
  text-align: center;
  > span {
    color: #467cf8;
    text-decoration: underline;
    cursor:pointer;
  }
  > img {
    position: absolute;
    top: -1rem;
    width: 5rem;
    display: none;
  }
  &:hover {
    > img {
      display: block;
    }
  }

  @media only screen and (max-width: 1024px) {
    > img {
      top: -1rem;
      right:0;
      width: 5rem;
    }
  }
`;

export default AquaReportTable;
